import "./GlStatement.scss";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import CircularButton, {
  CustomLoadingButton
} from "../../../components/ui/CustomButton";
import ExportToExcelButton from "../../../components/exportToExcelButton/ExportToExcelButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import newRequest from "../../../utils/newRequest";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  TableHead,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import { ScaleLoader } from "react-spinners";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { useTranslation } from "react-i18next";
import { fetchClientsBySearch } from "../../../utils/genericFunctions.js";
import { MdClose } from "react-icons/md";

const GlStatement = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isLoading, setIsLoading] = useState(false);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [statementTitle, setStatementTitle] = useState("");
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRiskNotes, setFilteredRiskNotes] = useState([]);
  const [filteredReceipts, setFilteredReceipts] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [statementData, setStatementData] = useState({});
  const [fmDate, setFmDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);
  // columns to export
  const exportColumns = [
    "insured_name_xx",
    "insured_code_xx",
    "carrier_name_xx",
    "carrier_code_xx",
    "pl_type",
    "pl_risk_note_no",
    "end_name_xx",
    "drcr_flag_xx",
    "policy_fc_premium",
    "total_fc_premium",
    "commission_fc_amount",
    "commission_tax_fc_amount",
    "commission_net_fc",
    "commission_net_fc",
    "running_balance_fc",
  ];


  const fetchProducts = async () => {
    try {

      const res = await newRequest.post("/uwProduct/findAll", { pr_org_code: currentUser.usr_org_code });
      // Transform the data to match the format expected by react-select
      const options = res.data.map((product) => ({
        value: product.pr_code,
        label: product.pr_name,
      }));

      options.unshift({ value: "All", label: "All" });

      setProducts(options);
      // set default product
      setSelectedProduct({ value: "All", label: "All" });
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const fetchBranches = async () => {
    try {

      const res = await newRequest.post("/orgUnit/findAll", {
        unit_org_code: currentUser.usr_org_code,
      });

      const options = res.data.map((branch) => ({
        value: branch.unit_code,
        label: branch.unit_name,
      }));

      options.unshift({ value: "All", label: "All" });
      setBranches(options);
      setSelectedBranch({ value: "All", label: "All" });
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data?.map((currency) => ({
        value: currency?.cur_code,
        label: currency?.cur_name,
      }));
      setCurrencies(options);

      setSelectedCurrency({
        value: currentUser?.currency_code_xx,
        label: currentUser?.currency_name_xx,
      })

    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const setDates = () => {
    try {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // Beginning of the year
      const beginningOfYear = new Date(currentYear, 0, 1);
      beginningOfYear.setFullYear(currentYear); // Set full year again to handle leap years
      const formattedBeginningOfYear = beginningOfYear
        .toISOString()
        .split("T")[0];

      // End of the year
      const endOfYear = new Date(currentYear + 1, 0, 0);
      const formattedEndOfYear = endOfYear.toISOString().split("T")[0];

      // Beginning of the month
      const beginningOfMonth = new Date(currentYear, currentMonth, 1);
      // console.log(`Begining of the month ${beginningOfMonth}`)
      const formattedBeginningOfMonth = beginningOfMonth
        .toISOString()
        .split("T")[0];

      // End of the month
      const endOfMonth = new Date(currentYear, currentMonth + 1, 0);
      endOfMonth.setDate(endOfMonth.getDate() + 1); // Add one day to get the actual end of the month
      const formattedEndOfMonth = endOfMonth.toISOString().split("T")[0];

      // Formatting current date and one year later
      const formattedCurrentDate = currentDate.toISOString().split("T")[0];
      const oneYearLater = new Date(currentDate);
      oneYearLater.setFullYear(currentYear + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split("T")[0];

      // console.log("Current Date:", formattedCurrentDate);
      // console.log("Beginning of the Year:", formattedBeginningOfYear);
      // console.log("End of the Year:", formattedEndOfYear);
      // console.log("Beginning of the Month:", formattedBeginningOfMonth);
      // console.log("End of the Month:", formattedEndOfMonth);
      // console.log("One Year Later:", formattedOneYearLater);

      // Set these values to your state or do whatever you want with them
      setFmDate(formattedBeginningOfMonth);
      setToDate(formattedEndOfMonth);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setDates();
    fetchProducts();
    fetchBranches();
    fetchCurrencies();
  }, []);

  const handleFromDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedFromDate = moment(e.target.value).format("YYYY-MM-DD");
        setFmDate(formattedFromDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleToDateChange = (e) => {
    try {
      if (e.target.value) {
        const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
        setToDate(formattedToDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetStatement = async () => {
    try {
      if (!selectedCarrier) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select entity`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await newRequest.post("/entityBalance/carrierStmt", {
        date_fm: fmDate,
        date_to: toDate,
        product_code: selectedProduct.value === "All" ? "" : selectedProduct?.value,
        biz_unit: selectedBranch?.value === "All" ? "" : selectedBranch?.value,
        currency_code: selectedCurrency?.value,
        aent_code: selectedCarrier?.ent_code === "All" ? "" : selectedCarrier?.aent_code,
        ent_code: selectedCarrier?.ent_code === "All" ? "" : selectedCarrier?.ent_code
      });
      // console.log(`carrierStmt  ${JSON.stringify(res.data, null, 2)}`);
      setStatementTitle(`${selectedCarrier?.ent_name?.toUpperCase()} ${selectedCurrency?.label} STATEMENT FOR ${moment(fmDate).format("DD-MMM-YYYY")} TO ${moment(toDate).format("DD-MMM-YYYY")}`)
      setStatementData(res.data);
    } catch (error) {
      console.log(error);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const filteredRiskNotes = statementData?.statement_data?.filter(
      (item) =>
        item.pl_quote_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pl_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pl_risk_note_no
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.pl_end_no
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.product_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.insured_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.created_by_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );

    const filteredReceipts = statementData.receipts_data?.filter(
      (item) =>
        item.hd_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.hd_ref_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.hd_fc_amount?.toString()
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.hd_chq_no
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    );

    const filteredPayments = statementData.payments_data?.filter(
      (item) =>
        item.hd_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.hd_ref_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.hd_fc_amount?.toString()
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.hd_chq_no
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    );
    setFilteredReceipts(filteredReceipts);
    setFilteredPayments(filteredPayments);
    setFilteredRiskNotes(filteredRiskNotes);

  }, [statementData.statement_data, searchTerm]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const slicedRiskNotes = filteredRiskNotes?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const slicedReceipts = filteredReceipts?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  const slicedPayments = filteredPayments?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  return (
    <motion.div
      className="gl-statement"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="content">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
            }}
          >
              <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
          </div>
        ) : (
          <div className="content-wrapper">
            <ExpandableComponent
              title={t('entityStatement').toUpperCase()}
              subtitle={""}
              defaultExpanded={true}
            >
              <div className="content-wrapper-selection">
                <h3 className="sub-title" style={{ alignSelf: "center" }}>{t('pleaseEnterSearch')}</h3>
                <div className="filter">
                  <div className="dates">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="fm_date"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('from').toUpperCase()}
                      </label>
                      <input
                        id="fm_date"
                        name="fm_date"
                        type="date"
                        placeholder="FROM"
                        value={fmDate}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        onChange={handleFromDateChange}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="to_date"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('to').toUpperCase()}
                      </label>
                      <input
                        id="to_date"
                        name="to_date"
                        type="date"
                        placeholder="TO"
                        value={toDate}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        onChange={handleToDateChange}
                      />
                    </div>
                  </div>
                  <div className="carrier">
                    <div className="input-item-with-label">
                      <label htmlFor="product_code" style={{ width: "130px" }}>
                        {t('product').toUpperCase()}
                      </label>
                      <Select
                        id="product_code"
                        name="product_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedProduct}
                        onChange={(selectedOption) => {
                          try {
                            setSelectedProduct(selectedOption);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={products}
                        isSearchable={true}
                        placeholder={t('product').toUpperCase()}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="carrier" style={{ width: "130px" }}>
                        {t('carrier').toUpperCase()}
                      </label>
                      <AsyncSelect
                        id="carrier_ent_code"
                        name="carrier_ent_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedCarrier}
                        onChange={(selectedOption) => setSelectedCarrier(selectedOption)}
                        loadOptions={fetchClientsBySearch}
                        isSearchable={true}
                        placeholder={t('carrier').toUpperCase()}
                        noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                      />
                    </div>
                  </div>
                  <div className="biz-unit">
                    <div className="input-item-with-label biz_unit">
                      <label htmlFor="biz_unit" style={{ width: "100px" }}>
                        {t('bizUnit').toUpperCase()}
                      </label>
                      <Select
                        id="biz_unit"
                        name="biz_unit"
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={selectedBranch}
                        onChange={(selectedOption) => {
                          try {
                            setSelectedBranch(selectedOption);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={branches}
                        isSearchable={true}
                        placeholder={t('bizUnit').toUpperCase()}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="currency_code" style={{ width: "100px" }}>
                        {t('currency').toUpperCase()}
                      </label>
                      <Select
                        id="currency_code"
                        name="currency_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={selectedCurrency}
                        onChange={(selectedOption) => {
                          try {
                            setSelectedCurrency(selectedOption);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        options={currencies}
                        isSearchable={true}
                        placeholder={t('currency').toUpperCase()}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", margin: "5px 0px" }}>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    endIcon={<PageviewOutlinedIcon />}
                    onClick={handleGetStatement}
                  >
                    {t('getStatement').toUpperCase()}
                  </CustomLoadingButton>
                </div>
              </div>
            </ExpandableComponent>
            <div className="content-wrapper-summary">
              <h1 className="main-title" style={{ width: "100%", textAlign: "center" }}>{statementTitle}</h1>
              <div className="summary-wrapper">
                <div className="count-view">
                  <h1 className="sub-title"> {numeral(statementData.opening_balance_fc || "0").format("0,0.00")}</h1>
                  <h3 className="sub-title soft">{t('openingBalance')}</h3>
                </div>
                <div className="count-view">
                  <h1 className="sub-title"> {numeral(
                    statementData.total_debit_fc || "0"
                  ).format("0,0.00")}</h1>
                  <h3 className="sub-title soft">{t('totalDebits')}</h3>
                </div>
                <div className="count-view">
                  <h1 className="sub-title"> {numeral(
                    statementData.total_credit_fc || "0"
                  ).format("0,0.00")}</h1>
                  <h3 className="sub-title soft">{t('totalCredits')}</h3>
                </div>
                <div className="premium-view">
                  <h1 className="sub-title">{statementData.no_of_transactions || "0.00"}</h1>
                  <h3 className="sub-title soft">{t('noOfTrans')}</h3>
                </div>
                <div className="sum-insured-view">
                  <h1 className="sub-title"> {numeral(
                    statementData.closing_balance_fc || "0"
                  ).format("0,0.00")}</h1>
                  <h3 className="sub-title soft">{t('closingBalance')}</h3>
                </div>
              </div>
            </div>
            {/* <div className="content-wrapper-products">
              <span>Breakdown By Product</span>
              <div className="product-wrapper">
              </div>
            </div> */}
            <div className="content-wrapper-result">
              <div className="results-wrapper">
                <div className="results-wrapper-navbar">
                  <div className="navbar-left">
                    <div className="search-input-wrapper" style={{ width: "90%" }}>
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="navbar-right">
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#0f766e5d"
                      endIcon={<RefreshIcon />}
                      onClick={handleGetStatement}
                    >
                      {t('refresh')}
                    </CustomLoadingButton>
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#2563EB"
                      tooltip="Run statement reports"
                      endIcon={<IoDocumentTextSharp />}
                      onClick={() => setReportsDialogOpen(true)}>
                      {t('reports')}
                    </CustomLoadingButton>
                    <ExportToExcelButton
                      data={filteredRiskNotes}
                      exportColumns={exportColumns}
                      fileName="Documents.xlsx"
                      currentTheme={currentTheme}
                      borderRadiusType="right"
                    />
                  </div>
                </div>
                <h1 className="main-title" style={{ margin: "10px 0px" }}>{t('riskNotes')}[{filteredRiskNotes?.length}]</h1>
                <div className="table-content">
                  <TableContainer component={Paper} className="table-container">
                    <Table sx={{ width: "max-content" }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                            <span>{t('type').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                            <span>{t('date').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", }}>
                            <span>{t('document').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                            <span>{t('endorsement').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            <span>{t('drcr').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span>{t('premium').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span>{t('paidPrem').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span>{t('osPrem').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span>{t('comm').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span>{t('balance').toUpperCase()}</span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedRiskNotes?.map((row, index) => (
                          <TableRow
                            key={row?._id}
                            className={`${selectedPolicy?._id === row?._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => {
                              try {
                                setSelectedPolicy(row);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{page * rowsPerPage + index + 1}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.pl_type}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{moment(row?.pl_gl_date).format("DD-MMM-YYYY")}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <div style={{ width: "100%", flexDirection: "column" }}>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.insured_name_xx}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.pl_risk_note_no} - {row?.product_name_xx}</h1>
                              </div>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.end_name_xx}</h1>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.drcr_flag_xx}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.total_lc_premium).format("0,0.00")}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.total_paid_fc_amount).format("0,0.00")}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.total_os_fc_amount).format("0,0.00")}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.commission_net_fc).format("0,0.00")}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.running_balance_fc).format("0,0.00")}</h1>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {filteredRiskNotes?.length > rowsPerPage &&
                      <TablePagination
                        rowsPerPageOptions={[10]}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        component="div"
                        count={filteredRiskNotes?.length}
                        rows={filteredRiskNotes}
                        page={page}
                        onPageChange={handleChangePage}
                      />}
                  </TableContainer>
                </div>
                <hr className="separator-h" />
                <h1 className="sub-title" style={{ margin: "10px 0px" }}>Unapplied and Partially Applied Receipts [{filteredReceipts?.length}]</h1>
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                    className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableBody className="tablebody">
                        {filteredReceipts?.map((receipt, index) => (
                          <TableRow
                            key={receipt._id}
                            className={`${selectedReceipt?._id === receipt._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => {
                              try {
                                setSelectedReceipt(receipt);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              {index + 1}
                            </TableCell>
                            <TableCell className="table-cell" style={{ maxWidth: "200px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>  {receipt?.hd_no} </h1>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{`Ref: ${receipt?.hd_ref_no}`}</h1>
                            </TableCell>
                            <TableCell className="table-cell" style={{ flexDirection: "column", width: "auto" }}>
                              <h1 className="sub-title">{receipt?.client_name_xx}</h1>
                              <h1 className="sub-title"> {receipt?.hd_mode}</h1>
                            </TableCell>
                            <TableCell className="table-cell" style={{ alignItems: "right", display: "flex", flexDirection: "column", maxWidth: "150px" }}>
                              <h1 style={{
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#f44336"
                              }}>{receipt?.hd_cur_code}</h1>
                              <span style={{
                                textAlign: "right",
                                fontWeight: "bold"
                              }}>{`Received ${numeral(
                                receipt?.hd_fc_amount
                              ).format("0,0.00")}`}</span>
                              <span
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >{`Allocated ${numeral(
                                receipt?.allocated_fc_amount_xx
                              ).format("0,0.00")}`}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              display: "flex",
                              flexDirection: "column",
                              maxWidth: "100px"
                            }}>
                              <span>{receipt?.hd_paying_for}</span>
                              <span style={{
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#9c27b0"
                              }}> {receipt?.bizunit_name_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              display: "flex",
                              flexDirection: "column",
                              maxWidth: "120px"
                            }}>
                              <span>
                                {moment(receipt?.hd_gl_date).format("DD-MMM-YYYY")}
                              </span>
                              <span style={{
                                fontWeight: "bold",
                                fontSize: "12px"
                              }} className={`status ${receipt?.hd_status}`}>
                                {receipt?.hd_status}
                              </span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              alignItems: "right",
                              display: "flex",
                              flexDirection: "column",
                              fontSize: "12px",
                              fontWeight: "bold",
                              maxWidth: "250px"
                            }}>
                              <span>{`worked on by... ${receipt?.updated_by_name_xx}`}</span>
                              <span> {receipt?.time_ago_xx}</span>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {/* <TablePagination
                        rowsPerPageOptions={[5]}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        component="div"
                        count={filteredReceiptsData.length}
                        page={page}
                        onPageChange={handleChangePage}
                      /> */}
                  </TableContainer>
                </div>
                <hr className="separator-h" />
                <h1 className="sub-title" style={{ margin: "10px 0px" }}>Unapplied and Partially Applied Payments [{filteredPayments?.length}]</h1>
                <div className="table-content">
                  <TableContainer component={Paper} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableBody className="tablebody">
                        {filteredPayments?.map((payment, index) => (
                          <TableRow
                            key={payment._id}
                            className={`${selectedPayment?._id === payment._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => {
                              try {
                                setSelectedPayment(payment);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              {index + 1}
                            </TableCell>
                            <TableCell className="table-cell" style={{ maxWidth: "200px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>  {payment?.hd_no} </h1>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{`Ref: ${payment?.hd_ref_no}`}</h1>
                            </TableCell>
                            <TableCell className="table-cell" style={{ flexDirection: "column", width: "auto" }}>
                              <h1 className="sub-title">{payment?.client_name_xx}</h1>
                              <h1 className="sub-title"> {payment?.hd_mode}</h1>
                            </TableCell>
                            <TableCell className="table-cell" style={{ alignItems: "right", display: "flex", flexDirection: "column", maxWidth: "150px" }}>
                              <h1 style={{
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#f44336"
                              }}>{payment?.hd_cur_code}</h1>
                              <span style={{
                                textAlign: "right",
                                fontWeight: "bold"
                              }}>{`Received ${numeral(
                                payment?.hd_fc_amount
                              ).format("0,0.00")}`}</span>
                              <span
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >{`Allocated ${numeral(
                                payment?.allocated_fc_amount_xx
                              ).format("0,0.00")}`}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              display: "flex",
                              flexDirection: "column",
                              maxWidth: "100px"
                            }}>
                              <span>{payment?.hd_paying_for}</span>
                              <span style={{
                                fontWeight: "bold",
                                fontSize: "10px",
                                color: "#9c27b0"
                              }}> {payment?.bizunit_name_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              display: "flex",
                              flexDirection: "column",
                              maxWidth: "120px"
                            }}>
                              <span>
                                {moment(payment?.hd_gl_date).format("DD-MMM-YYYY")}
                              </span>
                              <span style={{
                                fontWeight: "bold",
                                fontSize: "12px"
                              }} className={`status ${payment?.hd_status}`}>
                                {payment?.hd_status}
                              </span>
                            </TableCell>
                            <TableCell className="table-cell" style={{
                              alignItems: "right",
                              display: "flex",
                              flexDirection: "column",
                              fontSize: "12px",
                              fontWeight: "bold",
                              maxWidth: "250px"
                            }}>
                              <span>{`worked on by... ${payment?.updated_by_name_xx}`}</span>
                              <span> {payment?.time_ago_xx}</span>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {/* <TablePagination
                      rowsPerPageOptions={[6]}
                      component="div"
                      count={slicedPayments?.length}
                      rowsPerPage={rowsPerPage}
                      rows={slicedPayments}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                  </TableContainer>
                </div>

              </div>
            </div>
          </div>
        )}
      </div>

      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["carrier-statement"]}
                documentData={{
                  docNo: selectedCarrier?.ent_code,
                  docType: t('statement'),
                  docId: selectedCarrier?.ent_code,
                  clientEmail: "",
                  clientEntCode: selectedCarrier?.ent_code,
                  clientEntName: selectedCarrier?.ent_name,
                  filters: {
                    dateFm: fmDate,
                    dateTo: toDate,
                    currencyCode: selectedCurrency?.value,
                    productCode: selectedProduct.value === "All" ? "" : selectedProduct?.value,
                    bizUnit: selectedBranch?.value === "All" ? "" : selectedBranch?.value,
                    entCode: selectedCarrier?.ent_code,
                  }
                }} />
            </div>
          </div>
        </motion.div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default GlStatement;
